import Slider from '@ui/Slider/component'
import type { SliderOptions } from '@ui/Slider/component'

export default function (el: HTMLElement, config: SliderOptions = {}, lazy = true): void {
  if (!el || !(el instanceof Element)) {
    return
  }

  const defaultConfig: SliderOptions = {
    navigation: {
      nextEl: el.querySelector<HTMLElement>('.slider-button-next'),
      prevEl: el.querySelector<HTMLElement>('.slider-button-prev'),
    },
    speed: 300,
    lazy,
    slidesPerView: 'auto',
  }

  const paginationEl = el.querySelector<HTMLElement>('.slider-pagination')

  if (paginationEl) {
    defaultConfig.pagination = {
      el: paginationEl,
      type: 'custom',
      renderCustom: function (current: number, total: number) {
        return `${current}/${total}`
      },
    }
  }

  Slider(el, Object.assign({}, defaultConfig, config))
}
